export default __webpack_public_path__ + "fc6d225218c06661d07fb868f294b86b.jpg";